import React from 'react';
import { Box, Grid2 as Grid } from '@mui/material';
import { TextInput, useInputHelper, InputListTemplateProps } from 'framework/form';

const TabulerInputTemplate = ({ tableHeader = [], isLast, ...props }: InputListTemplateProps) => {
  const { getSource, getValue } = useInputHelper<string[]>(props);
  const source = getSource();
  const row = (getValue() || []) as string[];

  return (
    <Box
      sx={{
        borderBottom: isLast ? 'none' : '1px solid',
        borderColor: 'divider',
        pb: 1,
        mb: 1,
      }}
    >
      <Grid container spacing={1}>
        {row.map((_, cellIndex) => (
          <Grid
            // eslint-disable-next-line react/no-array-index-key
            key={cellIndex}
            sx={{
              minWidth: 120,
              flex: 1,
            }}
          >
            <TextInput label={tableHeader[cellIndex] || ''} placeholder="" source={`${source}.${cellIndex}`} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TabulerInputTemplate;
